module.exports = __webpack_public_path__ + "assets/img/last.cee896c1.png";